import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

const FilterComponent3 = (props) => {
  const {
    handleDuration,
    allCPs,
    isServiceRevenue,
    handleDownload,
    userSessions,
    networkData,
    networkOperators,
    setShowTable,
    setSelectedType,
  } = props;

  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: {
      errors: errors1,
      isSubmitting: isSubmitting1,
      isValid: isValid1,
    },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      type: "charging",
      cp_id: "",
      network_id: "1",
      from: new Date(Date.now() - 86400000).toISOString().substr(0, 10),
      to: new Date(Date.now() - 86400000).toISOString().substr(0, 10),
    },
  });

  useEffect(() => {
    handleSubmit1(handleDuration)();
  }, []);

  if (isServiceRevenue) {
    return (
      <div className="mb-10 mt-40" style={{ marginLeft: "-15px" }}>
        <form
          onSubmit={handleSubmit1(handleDuration)}
          style={{ display: "flex", flexWrap: "nowrap", alignItems: "flex-start", gap: "5px", width: "100%", paddingLeft: "15px" }}
        >
          <div style={{ flex: "0 0 160px" }}>
            <select
              className="filter_text"
              {...register1("type", { required: "Please select a type" })}
              style={{ textTransform: "capitalize" }}
              onChange={(e) => {
                setSelectedType(e.target.value);
                setShowTable(false);
              }}
            >
              <option value="">-Select Type-</option>
              {networkData &&
                networkData.length > 0 &&
                networkData.map((network) => (
                  <option key={network.id} value={network.value}>
                    {network.name}
                  </option>
                ))}
            </select>
            {errors1.type && (
              <small className="text-danger">{errors1.type.message}</small>
            )}
          </div>

          <div style={{ flex: "1 1 160px" }}>
            <select
              className="filter_text"
              {...register1("cp_id")}
              style={{ textTransform: "capitalize" }}
            >
              <option value="">-Select CP-</option>
              {allCPs &&
                allCPs.length > 0 &&
                allCPs.map((cp) => (
                  <option key={cp.id} value={cp.id}>
                    {cp.name}
                  </option>
                ))}
            </select>
            {errors1.cp_id && (
              <small className="text-danger">{errors1.cp_id.message}</small>
            )}
          </div>

          <div style={{ flex: "0 0 120px" }}>
            <select
              className="filter_text"
              {...register1("network_id")}
              style={{ textTransform: "capitalize" }}
            >
              {networkOperators &&
                networkOperators.length > 0 &&
                networkOperators.map((network) => (
                  <option key={network.id} value={network.id}>
                    {network.name}
                  </option>
                ))}
            </select>
          </div>

          <div style={{ flex: "0 0 145px" }}>
            <input
              type="date"
              className="filter_text"
              placeholder="From Date"
              {...register1("from", { required: "From date is required" })}
              max={new Date().toISOString().substr(0, 10)}
            />
            {errors1.from && (
              <small className="text-danger">{errors1.from.message}</small>
            )}
          </div>

          <div style={{ flex: "0 0 145px" }}>
            <input
              type="date"
              className="filter_text"
              placeholder="To Date"
              {...register1("to", { required: "To date is required" })}
              max={new Date().toISOString().substr(0, 10)}
            />
            {errors1.to && (
              <small className="text-danger">{errors1.to.message}</small>
            )}
          </div>

          <div style={{ flex: "0 0 80px" }}>
            <button
              className="btn_1 btn-primary w-100"
              type="submit"
              disabled={isSubmitting1}
              style={{ opacity: isSubmitting1 ? "0.5" : 1, minHeight: "38px" }}
            >
              {isSubmitting1 ? (
                <>
                  <i className="fa fa-spinner fa-spin mr-2"></i>
                  Loading...
                </>
              ) : (
                <>
                  <i className="fa fa-search mr-2"></i>
                  Filter
                </>
              )}
            </button>
          </div>

          <div style={{ flex: "0 0 90px" }}>
            <button
              className="btn_1 btn-primary w-100"
              type="button"
              onClick={handleDownload}
            >
              Download
            </button>
          </div>
        </form>
      </div>
    );
  }
};

export default FilterComponent3;
